import _ from 'lodash';

export const updateObject = (oldObject, updatedProperties) => {
    return {
        ...oldObject,
        ...updatedProperties
    };
};

export const checkValidity = (value, rules) => {
    let isValid = true;
    if (!rules) {
        return true;
    }

    if (rules.hasOwnProperty("required")) {
        isValid = value && value?.trim() !== '' && isValid;
    }

    if (rules.hasOwnProperty("minLength")) {
        isValid = value.length >= rules.minLength && isValid
    }

    if (rules.hasOwnProperty("maxLength")) {
        isValid = value.length <= rules.maxLength && isValid
    }

    if (rules.hasOwnProperty("isEmail")) {
        const pattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
        isValid = pattern.test(value) && isValid
    }

    if (rules.hasOwnProperty("isNumeric")) {
        const pattern = /^\d+$/;
        isValid = pattern.test(value) && isValid
    }

    if(rules.hasOwnProperty("minNumber")) {
        isValid = isValid && Number(value) > rules.minNumber;
    }

    return isValid;
}

export const removeZerosFromEndOfNumber = (number) => {
    if(number.includes('.')){
        while (number.charAt(number.length -1) === "0")
        {
            number = number.substring(0,number.length -1);
        }
        
        if (number.charAt(number.length -1) === ".")
        number = number.substring(0,number.length -1);
    }
    return number;
}
 
export const checkUrl = suspect => isURL ? null : "Not a valid URL";

function isURL(str) {
  var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
  '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|'+ // domain name
  '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
  '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
  '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
  '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
  return pattern.test(str);
}

  
  export function noExponents(num){
      var data= String(num).split(/[eE]/);
      if(data.length === 1) return data[0]; 
  
      var  z= '', sign= num<0? '-':'',
      str= data[0].replace('.', ''),
      mag= Number(data[1])+ 1;
  
      if(mag<0){
          z= sign + '0.';
          while(mag++) z += '0';
          //eslint-disable-next-line
          return z + str.replace(/^\-/,'');
      }
      mag -= str.length;  
      while(mag--) z += '0';
      return str + z;
  }

export const getQueryVariable = (variable) => {
    var query = window.location.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) === variable) {
            return decodeURIComponent(pair[1]);
        }
    }
    //console.log('Query variable %s not found', variable);
}

export const orderBy = (array, keys, sortBy) => {
    return _.orderBy(array, keys, sortBy);
}


export const onClickCopy = (e,val) => {
    var x = e.pageX,
        y = e.pageY;
    
    var textField = document.createElement('textarea')
    textField.innerText = val
    document.body.appendChild(textField)
    textField.select()
    document.execCommand('copy')
    textField.remove()
    var copied = document.createElement('span')
    copied.innerText = "Copied";
    copied.style = `
                position: absolute; 
                top: ${Number(y)-50}px; 
                left: ${Number(x)-40}px; 
                font-size: 14px;
                background-color: #00062a;
                border-radius: 8px 4px 8px 0px;
                color: #fff;           
                letter-spacing: 1px;
                font-family: roboto, sans-serif;
                padding: 5px 10px;
                z-index: 99999;
                `;
    document.body.appendChild(copied);
    setTimeout(()=>{copied.remove()},2000)
}

export const sortByKey = (array, key) => {
    return array.sort((a, b) =>{
        let x = b[key];
        let y = a[key]; 
        return ((x < y) ? -1 : ((x > y) ? 1 : 0)) 
    });
}


export const commaFormatted = (amount) => {
    var parts = amount.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
}

export const customFixed = (num, fixed) => {
    num = String(num);
    fixed = fixed + 1;
    if (num.length < 3) return num
    let fixed_num = "";
    let counter = 0;
    for (let i = 0; i < num.length; i++) {
        fixed_num = fixed_num + num[i];
        if (num[i] === "." || counter > 0) {
            counter++
            if (counter === fixed) {
                return fixed_num
            }
        }
    }
    return Number(fixed_num)
}